//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import Pickr from "@simonwep/pickr";
import Color from "color";

//
// Locals
//

const defaultColor = "#ffffff";

//
// Component
//

export function initialiseColorInput(colorInput: HTMLElement)
{
	//
	// Get Elements
	//

	const input = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLInputElement>(colorInput, `input[name="color"]`);

	const preview = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLDivElement>(colorInput, ".preview");

	const pickrContainer = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLDivElement>(colorInput, ".pickr-container");

	//
	// Create Picker
	//

	// @ts-ignore HACK: this package's exports are FUCKED
	const picker = Pickr.create(
		{
			el: preview,
			container: pickrContainer,
			useAsButton: true,
			default: input.value != "" ? input.value : defaultColor,
			components: 
			{
				preview: true,
				hue: true,

				interaction: 
				{
					input: true,
					clear: true,
				},
			},
		});

	//
	// Create Functions
	//

	const setPreviewTextColor = () =>
	{
		const color = Color.rgb(input.value != "" ? input.value : defaultColor);

		const textColor = color.isDark() ? "#FFFFFF" : "#000000";

		preview.style.color = textColor;
	}

	const onShow = () => preview.setAttribute("aria-expanded", "true");

	const onHide = () => preview.setAttribute("aria-expanded", "false");

	// @ts-ignore HACK: this package's exports are FUCKED
	const onChange = (color: Pickr.HSVaColor) =>
	{
		const colorHex = color.toHEXA().toString();

		input.value = colorHex;

		preview.style.backgroundColor = colorHex;

		setPreviewTextColor();
	};

	const onClear = () =>
	{
		picker.off("change", onChange);

		input.value = "";

		preview.style.backgroundColor = defaultColor;

		picker.setColor(defaultColor, true);

		setPreviewTextColor();

		picker.on("change", onChange);
	};

	//
	// Initialise
	//

	setPreviewTextColor();

	colorInput.addEventListener("keydown",
		(event) =>
		{
			switch (event.key)
			{
				case "Enter":
				case " ":
					picker.isOpen() ? picker.hide() : picker.show();

					break;

				case "Escape":
					picker.hide();

					break;
			}
		});

	picker.on("show", onShow);
	
	picker.on("hide", onHide);

	picker.on("change", onChange);

	picker.on("clear", onClear);

	colorInput.classList.add("initialised");
}

export function initialiseColorInputs()
{
	const colorInputs = document.querySelectorAll<HTMLElement>(".component-color-input:not(.initialised)");

	console.log("[ColorInput] Initialising " + colorInputs.length + " instances...");

	for (const colorInput of colorInputs)
	{
		try
		{
			initialiseColorInput(colorInput);
		}
		catch (error)
		{
			console.error("[ColorInput] Error initialising:", colorInput, error);
		}
	}
}